import Styled from 'styled-components';

export const LabelEntityCountsStyled = Styled.div`
	font-size: 13px;
	font-weight: ${props => props.header ? 700 : 'normal'};
	opacity: ${props => props.disabled ? 0.5 : 1}
`;
